/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Polygon } from 'react-native-svg';

import { IconProps } from '../lib';

function CaretLeft(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Polygon points="160 208 80 128 160 48 160 208" opacity={0.2} />
      <Polygon
        points="160 208 80 128 160 48 160 208"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default CaretLeft;
